export const ICON_STYLE_ID = 'email-clicked-link-inline-style';
export const ICON_TARGET_ATTR = 'data-email-icon-target';
export const ICON_HORIZONTAL_OFFSET = 8;
export const EMAIL_PREVIEW_BODY_CLASS = 'email-preview-body';
export const EMAIL_CLICKED_LINK_CLASS = 'email-clicked-link';
